import { Box, Typography, Stack, Link as MuiLink, useTheme } from '@mui/material';
import React from 'react';
import { Link } from 'react-router-dom';
import { HOMEOWNER_PORTAL_ROUTES } from '../routes';
import smbLogo from '../../../assets/homeowner-portal/smb_white_logo.png';

interface NavigationLink {
  label: string;
  path: string;
}

export const HomeownerFooter: React.FC = () => {
  const theme = useTheme();

  const navigationLinks: NavigationLink[] = [
    { label: 'Home', path: HOMEOWNER_PORTAL_ROUTES.LANDING },
    { label: 'About My Home', path: HOMEOWNER_PORTAL_ROUTES.ABOUT_MY_HOME },
    { label: 'My Community', path: HOMEOWNER_PORTAL_ROUTES.LEARN_MORE_COMMUNITY },
    { label: 'Phases of Construction', path: HOMEOWNER_PORTAL_ROUTES.CONSTRUCTION_PHASES },
    { label: 'Referral Program', path: HOMEOWNER_PORTAL_ROUTES.REFERRAL },
    { label: 'Submit Photos', path: HOMEOWNER_PORTAL_ROUTES.SUBMIT_PHOTOS },
    { label: 'Warranty Portal', path: HOMEOWNER_PORTAL_ROUTES.WARRANTY_PORTAL }
  ];

  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: 'primary.dark',
        color: 'white',
        py: { xs: 2, md: 3 },
        px: 2,
        mt: 'auto'
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: { xs: 2, md: 3 },
          maxWidth: 1200,
          mx: 'auto'
        }}
      >
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          spacing={{ xs: 1, sm: 2, md: 3 }}
          sx={{
            flexWrap: 'wrap',
            justifyContent: 'center',
            alignItems: 'center',
            flex: 1
          }}
        >
          {navigationLinks.map(link => (
            <MuiLink
              key={link.path}
              component={Link}
              to={link.path}
              sx={{
                color: 'inherit',
                textDecoration: 'none',
                fontSize: { xs: '0.75rem', sm: '0.875rem' },
                '&:hover': {
                  textDecoration: 'underline'
                },
                '&:focus': {
                  textDecoration: 'underline',
                  outline: `2px solid ${theme.palette.primary.light}`,
                  outlineOffset: 2
                }
              }}
            >
              {link.label}
            </MuiLink>
          ))}
        </Stack>

        <MuiLink
          href="https://www.stonemartinbuilders.com/"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Visit Stone Martin Builders website"
          sx={{
            display: 'flex',
            alignItems: 'center',
            textDecoration: 'none',
            '&:focus': {
              outline: `2px solid ${theme.palette.primary.light}`,
              outlineOffset: 2,
              borderRadius: 1
            }
          }}
        >
          <Box
            component="img"
            src={smbLogo}
            alt="Stone Martin Builders"
            sx={{
              height: { xs: 48, md: 60 },
              width: 'auto',
              maxWidth: '100%'
            }}
          />
        </MuiLink>
      </Box>

      <Typography
        variant="caption"
        sx={{
          display: 'block',
          textAlign: 'center',
          mt: { xs: 2, md: 3 },
          fontSize: { xs: '0.7rem', sm: '0.75rem' }
        }}
      >
        © Stone Martin Builders, LLC {new Date().getFullYear()}. All Rights Reserved.
      </Typography>
    </Box>
  );
};
